import React, { FunctionComponent, useState } from "react";
import {
  Fab,
  Grid,
  Table,
  Tooltip,
  MuiThemeProvider,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import EditIcon from "@material-ui/icons/Edit";
import Switch from "@material-ui/core/Switch";
import { useStore } from "../../../../store";
import { useTerminalsStyles } from "../useTerminalsStyles";
import { TerminalType } from "../../terminalType";
import { SnackBar } from "../../../SnackBar";
import MUIDataTable from "mui-datatables";
import { useTableStyles } from "../../../useTableStyle";
import { ThemeProvider } from "@mui/material/styles";

const columns = [
  "Name",
  "Address",
  "Port No",
  "Database Name",
  "Database User",
  "Status",
  ""
];

const emptyOptions = {
  pagination: false,
  selectableRows: undefined,
  selectableRowsHeader: false,
  print: false,
  search: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

const options = {
  selectableRows: undefined,
  selectableRowsHeader: false,
  rowsPerPage: 10,
  rowsPerPageOptions: [5, 10, 15, 25, 50, 100],
  print: false,
  download: false,
  filter: false,
  viewColumns: false,
  display: true,
  responsive: undefined,
  fixedHeaderOptions: {
    xAxis: false,
    yAxis: true,
  },

  isRowSelectable: function () {
    return false;
  },
};

interface TerminalsTableProps {
  terminal: Array<TerminalType>;
  handleEdit: (id: number) => void;
  editTerminalPermission: boolean;
};

export const TerminalsTable: FunctionComponent<TerminalsTableProps> = ({
  terminal,
  handleEdit,
  editTerminalPermission,
}) => {
  const [terminals, { getTerminals, updateTerminal }] = useStore("terminals");
  const [terminalName, setTerminalName] = useState<string>("");
  const [terminalStatus, setTerminalStatus] = useState<string>("");
  const [statusUpdate, setStatusUpdate] = useState<string>("");
  const [snackbarColor, setSnackbarColor] = useState<string>("#d50000");
  const classes = useTerminalsStyles();
  const getMuiTheme = useTableStyles();
  const [status] = useStore("status");
  const [openConfirmation, setOpenConfirmation] = useState<boolean>(false);
  const [terminalId, setTerminalId] = useState<number>();

  const onCloseSnackbar = () => {
    setStatusUpdate("");
  };

  const handleChange = (id: number, status: string, name: string) => {
    setOpenConfirmation(true);
    setTerminalName(name);
    setTerminalStatus(status);
    setTerminalId(id);
  };

  const changeStatus = async (dept_status: string) => {
    try {
      const status_description =
        dept_status === "Active" ? "Inactive" : "Active";
      const statusId =
        status &&
        status.find((i: any) => i.description === status_description).id;

      const values = {
        status: statusId,
      };
      const result = await updateTerminal(terminalId, values);

      if (result !== undefined) {
        setOpenConfirmation(false);
        setSnackbarColor("green");
        setStatusUpdate("Status updated successfully");
        await getTerminals();
      }
    } catch (error:any) {
      console.log(error);
      setSnackbarColor("red");
      setTerminalStatus(error.error);
    }
  };

  if (terminals && terminals.length > 0) {
    return (
      <div>
        <SnackBar
          status={statusUpdate}
          onCloseError={onCloseSnackbar}
          color={snackbarColor}
        />

        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Terminals List"}
              data={terminals.map((terminal: any) => {
                return [
                  terminal.name,
                  terminal.address,
                  terminal.db_port,
                  terminal.db_name,
                  terminal.db_user,
                  terminal.status_description,
                  <Grid container direction="row" spacing={2}
                    style={{ display: editTerminalPermission ? "" : "none" }}
                  >
                    <Grid item>
                      <Tooltip title="Edit">
                        <Fab
                          size="small"
                          aria-label="edit"
                          color="primary"
                          className={classes.editIconMargin}
                          onClick={() => handleEdit(terminal.id)}
                        >
                          <EditIcon className={classes.editIcon} />
                        </Fab>
                      </Tooltip>
                    </Grid>
                    <Grid item>
                      <Tooltip
                        title={
                          terminal.status_description === "Active"
                            ? "Change Status to Inactive"
                            : "Change Status to Active"
                        }
                      >
                        <Switch
                          checked={
                            terminal.status_description === "Active"
                              ? true
                              : false
                          }
                          onClick={() =>
                            handleChange(
                              terminal.id,
                              terminal.status_description,
                              terminal.name
                            )
                          }
                          style={{color:terminal.status_description === "Active"?"#3d5a79": undefined}}
                          color="primary"
                          name="status"
                          inputProps={{ "aria-label": "primary checkbox" }}
                        />
                      </Tooltip>{" "}
                    </Grid>
                  </Grid>
                ];
              })}
              columns={columns}
              options={options}
            />
          </ThemeProvider>
        </Table>
        <Dialog
          open={openConfirmation}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {terminalStatus === "Active"
                ? `Would you like to change status of ${terminalName} to Inactive?`
                : `Would you like to change status of ${terminalName} to Active?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => changeStatus(terminalStatus)} id="buton">
              Yes
          </Button>
            <Button
              onClick={() => setOpenConfirmation(false)}
              autoFocus
              id="buton"
            >
              No
          </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return (
      <div>
        <Table>
          <ThemeProvider theme={getMuiTheme}>
            <MUIDataTable
              title={"Terminals List"}
              columns={columns}
              data={[]}
              options={emptyOptions}
            />
          </ThemeProvider>
        </Table>
      </div>
    );
  }
};
